export default __webpack_public_path__ + "static/media/exclamation-circle.886cb980.svg";